<script setup>
import { useI18n } from "vue-i18n";
import { FormCheckboxGroup, FormCheckboxGroupOption } from "@Components/Form";

defineProps(["modelValue"]);
defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();

const positions = [
    {
        key: "top",
        name: __("Haut"),
        description: __("Ajouter des liens en haut de la publication."),
    },
    {
        key: "inter_sections",
        name: __("Inter Sections"),
        description: __("Ajouter des liens entre les H2 de la publication."),
    },
    {
        key: "bottom",
        name: __("Bas"),
        description: __("Ajouter des liens en bas de la publication."),
    },
];
</script>

<template>
    <FormCheckboxGroup :label="__('Positions')">
        <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            <FormCheckboxGroupOption
                v-for="position in positions"
                :key="position.key"
                v-model="modelValue.positions[position.key]"
                :title="position.name"
                :description="position.description"
            />
        </div>
    </FormCheckboxGroup>
</template>
